import {CommonModule} from '@angular/common';
import {Component, computed, inject, output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {ProductGroupsFacade} from '@em/data-feed/data-access-products';
import {
  EmIconModule,
  EmPrimaryButtonComponent,
  EmRadioModule,
  EmSelectModule,
  EmSpinnerModule,
  EmTextButtonComponent,
} from '@em/shared/ui';
import {TranslateModule} from '@ngx-translate/core';

type ProductGroupType = 'custom' | 'template';
@Component({
  selector: 'em-new-product-group-dialog',
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    MatDialogModule,
    EmSpinnerModule,
    EmRadioModule,
    EmSelectModule,
    EmIconModule,
    EmTextButtonComponent,
    EmPrimaryButtonComponent,
  ],
  templateUrl: './new-product-group-dialog.component.html',
  styleUrls: ['./new-product-group-dialog.component.scss'],
})
export class NewProductGroupDialogComponent {
  // Providers Injections
  readonly #productGroupsFacade = inject(ProductGroupsFacade);
  readonly #dialogRef = inject(MatDialogRef<NewProductGroupDialogComponent>);

  // Output
  readonly save = output<{templateName?: string}>();

  readonly groupTemplatesQuery =
    this.#productGroupsFacade.getAvailableGroupTemplates(undefined);
  readonly groupTempaltes = this.groupTemplatesQuery.data;
  readonly allTemplatesAdded = computed(
    () => !this.groupTempaltes()?.find((template) => !template.isAdded),
  );

  groupType: ProductGroupType = 'custom';
  template = '';
  missingTemplate = false;

  submit() {
    if (this.groupType === 'custom') {
      this.save.emit({});
      this.#dialogRef.close();
    } else if (this.groupType === 'template') {
      if (this.template) {
        this.save.emit({templateName: this.template});
        this.#dialogRef.close();
      } else {
        this.missingTemplate = true;
      }
    }
  }
}
